import { supabase } from "@/lib/supabase";
import { debugLog } from "./debug";

/**
 * Get topic tags for a reflection, including auto-tagging from group assignments
 */
export async function getTopicTags(
	user: { id: string },
	selectedCategory: string | null,
): Promise<string[]> {
	// Auto-tag with group-assigned topics if not already tagged
	let topicTags = selectedCategory ? [selectedCategory] : [];

	// If no manual topic selection, try to auto-tag based on user's group assignments
	if (topicTags.length === 0) {
		try {
			debugLog(
				"🔍 No manual topic selected, checking for group-assigned topics...",
			);

			// Get user's group memberships
			const { data: memberships, error: memberError } = await supabase
				.from("group_memberships")
				.select("group_id")
				.eq("mentee_id", user.id);

			if (!memberError && memberships && memberships.length > 0) {
				const groupIds = memberships.map((m) => m.group_id);

				// Get topic assignments for these groups
				const { data: assignments, error: assignmentError } = await supabase
					.from("topic_assignments")
					.select("topic_id")
					.in("group_id", groupIds);

				if (!assignmentError && assignments && assignments.length > 0) {
					topicTags = assignments.map((a) => a.topic_id);
					console.log(
						`✅ Auto-tagged reflection with ${topicTags.length} group-assigned topics: ${topicTags.join(", ")}`,
					);
				}
			}
		} catch (error) {
			console.warn("⚠️ Could not auto-tag with group topics:", error);
		}
	}

	return topicTags;
}
